<template>
  <div class="card">
    <template v-if="hasHeaderSlot">
      <div class="content" :class="{'card-padding': hasHeaderPadding}">
        <slot name="header"></slot>
      </div>
    </template>

    <div class="content" :class="{'card-padding': hasContentPadding}">
      <slot></slot>
    </div>

    <template v-if="hasFooterSlot">
      <div class="separator"/>

      <div class="content" :class="{'card-padding': hasFooterPadding}">
        <slot name="footer"></slot>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'Card',
  props: {
    hasFooterPadding: {
      type: Boolean,
      default: true,
    },
    hasHeaderPadding: {
      type: Boolean,
      default: true,
    },
    hasContentPadding: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/riseup-colors';
@import '../scss/riseup-vars';

  .card {
    font-family: SimplerPro;
    min-height: 40px;
    width: 100%;
    border-radius: 8px;
    box-shadow: 0px 5px 10px rgba(48, 57, 68, 0.15);
    overflow: hidden;

    .content {
      height: 100%;
    }

    .card-padding{
      padding: $card_padding;
    }

    .separator {
      height: 1px;
      width: 100%;
      background: $riseup_gray_0;
    }
  }
</style>
